import { Box, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core'
import React from 'react'
import { Globe } from 'react-feather'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  TemperatureCurveFragment,
  TemperatureCurveType,
} from '../../../../../generated/graphql'
import { validators } from '../../../../../validation/validators'
import { ControlledTextField } from '../../../../form/ControlledTextField'
import { FormGroup } from '../../../../form/FormGroup'
import { InternalFormValues } from '../../form-values'

type Props = {
  temperatureCurves: TemperatureCurveFragment[]
}

export function CoolingOptions({
  temperatureCurves,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const { control, errors } = useFormContext<InternalFormValues>()

  return (
    <Box flexGrow={1} display="flex" flexDirection="column">
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.hybridHeatPump.coolingTemperatureCurveId"
          rules={{ ...validators.required }}
          error={errors.parameters?.hybridHeatPump?.coolingTemperatureCurveId}
          label={t(
            'createProvider.forms.hybridHeatPump.coolingTemperatureCurveId',
          )}
          select
        >
          {temperatureCurves.map((curve) => (
            <MenuItem value={curve.id} key={curve.id}>
              {curve.type === TemperatureCurveType.ProjectSpecific ? (
                <ListItemText>{curve.name}</ListItemText>
              ) : (
                <Box display="flex" alignItems="center">
                  <ListItemIcon>
                    <Globe />
                  </ListItemIcon>
                  <ListItemText>{curve.name}</ListItemText>
                </Box>
              )}
            </MenuItem>
          ))}
        </ControlledTextField>
      </FormGroup>
    </Box>
  )
}
